// extracted by mini-css-extract-plugin
export default {"formGrid":"styles_formGrid__aP9WV","buttonContainer":"styles_buttonContainer__tM+zF","switchContainer":"styles_switchContainer__JXOfi","switchItem":"styles_switchItem__TEgyS"};